/* ============================================================================
   PJ Side Cart — drawer global do tema [QUIZ V2] Proper Jack.
   Substitui o cart drawer antigo (cart-ajax.js + side-drawer.liquid). Funciona
   em todas as páginas do tema.

   Exposto em window.pjSideCart = { open, close, addItem, load }.
   Intercepta clicks no .cart-icon / .openCartDrawer pra abrir o nosso drawer.
   v3.1 (17/07) — checkout YEVER (compra única + assinatura no mesmo fluxo).
   Mantém o pre-warm da URL de checkout (fast path) e decora a URL no clique
   com UTMs/cookies de tracking via snippet yever-checkout.liquid (com
   fallback local idêntico). Diferente do fluxo Yampi antigo, o carrinho NÃO
   é limpo após o redirect — a Yever lê o cart/token da Shopify.
   Checkout é EXCLUSIVAMENTE Yever (decisão 17/07): falha/timeout/inativa não
   redireciona pro /checkout nativo — botão reabilita com aviso de retry.
   ============================================================================ */
(function () {
  'use strict';

  var FREE_SHIPPING_CENTS = 25000; // R$ 250,00 (V13; no tema live segue 200 — decisão 08/07)
  /* ---- BRINDES POR VALOR (16/09) ----
     SÓ DEMONSTRATIVO: a Yever adiciona o brinde no checkout (regra dela). Aqui nada entra no /cart.
     A config vem do snippet (script[data-sc-gifts], produtos REAIS): cents = valor do pedido que libera,
     name = nome na régua/linha, img = foto, value = valor cheio (entra em "Você economiza"). */
  var GIFT_TIERS = [
    { cents: 30000, label: '1º brinde', name: '', img: '', value: 0 },
    { cents: 40000, label: '2º brinde', name: '', img: '', value: 0 },
    { cents: 50000, label: '3º brinde', name: '', img: '', value: 0 }
  ];
  var giftCfgOk = false;
  /* o snippet entrega nome/foto/valor de cada brinde em script[data-sc-gifts]; le 1x quando o DOM existir */
  function giftTiers() {
    if (giftCfgOk) return GIFT_TIERS;
    var cfg = document.querySelector('script[data-sc-gifts]');
    if (!cfg) return GIFT_TIERS;
    giftCfgOk = true;
    try {
      var arr = JSON.parse(cfg.textContent || '[]');
      if (arr && arr.length) GIFT_TIERS = arr.map(function (t, i) {
        return { cents: parseInt(t.cents, 10) || 0, label: (i + 1) + 'º brinde', name: t.name || '', img: t.img || '', value: parseInt(t.value, 10) || 0 };
      });
    } catch (e) { console.error('[pj-sc] gifts cfg:', e); }
    return GIFT_TIERS;
  }
  function reais(cents) { return 'R$ ' + fmt(cents).replace(/,00$/, ''); }
  var YEVER_CART_ENDPOINT = 'https://api.yever.com.br/checkout/V1/shopify';
  var CART_CACHE_MS = 5000; // 5s — evita refetch consecutivo do /cart.js
  var state = { data: null, fetchedAt: 0 };
  // Cache da URL de checkout da Yever. Chave = hash do estado do cart.
  // SEM TTL de tempo: o dev da Yever confirmou (17/07) que a URL é ESTÁVEL por
  // carrinho — só muda quando o carrinho muda. A chave (itens+qty+total+cupons)
  // já cobre isso. A URL é decorada com UTMs/token/cupom só na hora do CLIQUE.
  var checkoutCache = { url: null, cartKey: null, inflight: false };

  function cartKey(data) {
    if (!data || !data.items || !data.items.length) return '';
    var parts = [];
    for (var i = 0; i < data.items.length; i++) {
      parts.push(data.items[i].key + ':' + data.items[i].quantity);
    }
    /* cupons entram na chave: aplicar/remover cupom (mesmo sem mudar total, ex.
       frete grátis) invalida a URL pré-aquecida */
    var codes = '';
    try {
      codes = (data.discount_codes || []).filter(function (d) { return d.applicable; })
        .map(function (d) { return d.code; }).join('+');
    } catch (_) {}
    return data.item_count + '|' + data.total_price + '|' + parts.join(',') + '|' + codes;
  }

  /* mutação de carrinho em voo (changeQty/addItem) — o checkout espera ela
     terminar antes de montar o payload, senão redireciona com cart defasado */
  var pendingMutation = null;
  function trackMutation(p) {
    pendingMutation = p;
    var clear = function () { if (pendingMutation === p) pendingMutation = null; };
    p.then(clear, clear);
    return p;
  }

  function warmCheckout() {
    /* assinatura TAMBÉM vai pra Yever — sem skip por selling plan */
    if (!state.data || !state.data.items || state.data.items.length === 0) return;
    if (checkoutCache.inflight) return;
    var key = cartKey(state.data);
    if (checkoutCache.url && checkoutCache.cartKey === key) {
      return; // URL estável por carrinho — cache válido enquanto a chave bater
    }
    checkoutCache.inflight = true;
    /* formato do snippet yever-checkout.liquid: { payload, shopifyDomain } */
    var payload = {
      payload: state.data,
      shopifyDomain: (window.Shopify && window.Shopify.shop) || 'properjack.myshopify.com'
    };
    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    };
    try { opts.priority = 'low'; } catch (_) {}
    /* timeout de 8s: sem ele, um fetch pendurado deixa inflight=true pra sempre
       e NENHUM warm futuro roda */
    var ctl = null, tId = null;
    if ('AbortController' in window) {
      ctl = new AbortController();
      opts.signal = ctl.signal;
      tId = setTimeout(function () { try { ctl.abort(); } catch (_) {} }, 8000);
    }
    fetch(YEVER_CART_ENDPOINT, opts)
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        /* só cacheia se a Yever está ativa e devolveu URL */
        if (resp && resp.url && resp.active !== false) {
          checkoutCache.url = resp.url;
          checkoutCache.cartKey = key;
        }
      })
      .catch(function () { /* slow path no checkoutYever cobre */ })
      .then(function () {
        if (tId) clearTimeout(tId);
        checkoutCache.inflight = false;
        /* cart mudou enquanto o POST voava? re-aquece pro estado novo */
        if (state.data && cartKey(state.data) !== key) warmCheckout();
      });
  }

  function getRoot() { return document.getElementById('pj-sc'); }
  function $(sel) {
    var r = getRoot();
    return r ? r.querySelector(sel) : null;
  }
  function $$(sel) {
    var r = getRoot();
    return r ? r.querySelectorAll(sel) : [];
  }
  function fmt(cents) {
    if (typeof cents !== 'number') return '0,00';
    return (cents / 100).toFixed(2).replace('.', ',');
  }
  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function open() {
    var root = getRoot();
    if (!root) return;
    wire(); /* garante handlers ANTES da 1ª interação (rIC pode demorar ~2s) */
    liftStrips();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    load();
  }
  function close() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function load(force) {
    // Cache de 5s: evita refetch quando user abre/fecha o drawer rapidamente.
    // Mutações (changeQty, addItem) invalidam manualmente via state.fetchedAt = 0.
    if (!force && state.data && (Date.now() - state.fetchedAt) < CART_CACHE_MS) {
      render();
      warmCheckout();
      return Promise.resolve(state.data);
    }
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      state.data = data;
      state.fetchedAt = Date.now();
      render();
      warmCheckout();
      return data;
    })
    .catch(function (err) { console.error('[pj-sc] load:', err); });
  }

  function render() {
    renderItems();
    renderSubtotal();
    renderFreight();
    renderDigital();
    ensureCompares();
    repriceUpsells();
    hideUpsells();
    liftStrips();
  }

  /* 16/09: faixas de timer (campanha .pjc-sc-cd / cupom do gate .pjdg-sc-cd) nascem acima do FINALIZAR;
     movemos pro slot [data-sc-top] no topo do painel e empurramos o X pra baixo da faixa */
  var stripsObs = null;
  function liftStrips() {
    try {
      var root = getRoot(), top = $('[data-sc-top]'), foot = root && root.querySelector('.pj-sc-foot');
      if (!root || !top) return;
      root.querySelectorAll('.pj-sc-foot .pjc-sc-cd, .pj-sc-foot .pjdg-sc-cd').forEach(function (el) { top.appendChild(el); });
      var closeBtn = root.querySelector('.pj-sc-close');
      var h = top.children.length ? top.offsetHeight : 0;
      if (closeBtn) closeBtn.style.setProperty('top', (h ? h + 10 : 12) + 'px', 'important');
      if (!stripsObs && foot && window.MutationObserver) {
        var agenda = null;
        stripsObs = new MutationObserver(function () { clearTimeout(agenda); agenda = setTimeout(liftStrips, 0); });
        stripsObs.observe(foot, { childList: true });
        stripsObs.observe(top, { childList: true });
      }
    } catch (e) { console.error('[pj-sc] liftStrips:', e); }
  }

  /* 09/09: bump que duplicaria uma linha do carrinho some enquanto o produto (data-up-hide-handle)
     estiver no carrinho. Ex.: pack-3 do Deep Blue quando o cliente já tem o Sabonete Deep Blue oficial. */
  function hideUpsells() {
    try {
      var items = (state.data && state.data.items) || [];
      var lis = $$('.pj-sc-upsell-item[data-up-hide-handle]');
      Array.prototype.forEach.call(lis, function (li) {
        var h = li.getAttribute('data-up-hide-handle'), hide = false;
        for (var i = 0; i < items.length; i++) { if (items[i].handle === h) { hide = true; break; } }
        li.style.display = hide ? 'none' : '';
      });
    } catch (e) { console.error('[pj-sc] hideUpsells:', e); }
  }

  /* 09/09: order bumps do programa "Monte seu Kit" mostram o preço COM o desconto progressivo
     que vai valer depois de adicionar (o próprio bump conta na quantidade: 2=5% 3=10% 4=15% 5+=20%).
     Lista de variantes/tiers vem do snippet (data-sc-kitprog / data-sc-kittiers) e só existe fora
     das páginas Deep Blue (lá o gate reprecifica os bumps com o cupom). Sem item elegível no
     carrinho, o bump volta ao preço normal (1 item sozinho não tem desconto). */
  function repriceUpsells() {
    try {
      var sec = $('[data-sc-upsell]');
      if (!sec) return;
      var progAttr = sec.getAttribute('data-sc-kitprog');
      if (!progAttr) return;
      var prog = {};
      progAttr.split(',').forEach(function (id) { id = id.trim(); if (id) prog[id] = 1; });
      var tiers = (sec.getAttribute('data-sc-kittiers') || '2:5,3:10,4:15,5:20').split(',').map(function (t) {
        var p = t.split(':'); return { n: parseInt(p[0], 10) || 0, pct: parseInt(p[1], 10) || 0 };
      }).sort(function (a, b) { return a.n - b.n; });
      var pctFor = function (n) { var pct = 0; tiers.forEach(function (t) { if (n >= t.n) pct = t.pct; }); return pct; };
      var items = (state.data && state.data.items) || [], count = 0;
      items.forEach(function (it) { if (prog[String(it.variant_id)]) count += (it.quantity || 0); });
      var lis = $$('.pj-sc-upsell-item');
      Array.prototype.forEach.call(lis, function (li) {
        var vid = li.getAttribute('data-variant-id');
        if (!prog[vid]) return;
        var base = parseInt(li.getAttribute('data-up-base'), 10);
        if (!(base > 0)) return;
        var cmp = parseInt(li.getAttribute('data-up-cmp'), 10) || 0;
        var priceEl = li.querySelector('.pj-sc-upsell-price');
        if (!priceEl) return;
        /* guarda o markup/preço originais 1x pra poder voltar ao normal */
        if (li.getAttribute('data-up-html0') == null) {
          li.setAttribute('data-up-html0', priceEl.innerHTML);
          li.setAttribute('data-up-price0', li.getAttribute('data-up-price') || '');
        }
        var pct = pctFor(count + 1);
        if (!pct) {
          if (priceEl.innerHTML !== li.getAttribute('data-up-html0')) priceEl.innerHTML = li.getAttribute('data-up-html0');
          li.setAttribute('data-up-price', li.getAttribute('data-up-price0'));
          return;
        }
        var fin = Math.round(base * (100 - pct) / 100);
        var strike = Math.max(cmp, base);
        var html = '<s class="pj-sc-upsell-orig">R$ ' + fmt(strike) + '</s>R$ ' + fmt(fin);
        /* 1 pill só (Carlos, 09/09): com compare_at, mostra o desconto TOTAL sobre o "de"
           (oferta + kit somados); sem compare_at, só a parcela do kit */
        if (cmp > base) html += '<em class="pj-sc-upsell-off">OFERTA -' + Math.round(100 - fin * 100 / cmp) + '%</em>';
        else html += '<em class="pj-sc-upsell-off pj-sc-upsell-off--kit">-' + pct + '% no kit</em>';
        if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
        li.setAttribute('data-up-price', fmt(fin)); /* modal de detalhes lê daqui */
      });
    } catch (e) { console.error('[pj-sc] repriceUpsells:', e); }
  }

  /* carrinho 100%% digital (só gift card, requires_shipping=false): sem cotação de
     frete e sem barra de frete grátis — CSS esconde via .pj-sc--digital */
  function renderDigital() {
    var digital = !!(state.data && state.data.items && state.data.items.length && state.data.requires_shipping === false);
    var root = getRoot();
    if (root) root.classList.toggle("pj-sc--digital", digital);
    var note = $("[data-sc-digital]");
    if (note) note.hidden = !digital;
  }

  /* compare_at_price ("de R$") não vem no /cart.js — busca 1x por handle via /products/{handle}.js
     e re-renderiza quando chegar. Assim TODO item mostra o valor cheio riscado + o que paga. */
  var cmpCache = {};   // variant_id -> compare_at_price em cents (0 = sem "de")
  var cmpLoaded = {};  // handle -> true (fetch já disparado)
  function ensureCompares() {
    var items = (state.data && state.data.items) || [];
    var pend = [];
    items.forEach(function (it) {
      if (it.handle && !cmpLoaded[it.handle]) {
        cmpLoaded[it.handle] = true;
        pend.push(fetch('/products/' + it.handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p && p.variants) p.variants.forEach(function (v) { cmpCache[v.id] = v.compare_at_price || 0; });
          })
          .catch(function () {}));
      }
    });
    if (pend.length) Promise.all(pend).then(function () { renderItems(); renderSubtotal(); });
  }

  function renderItems() {
    var itemsEl = $('[data-sc-items]');
    var emptyEl = $('[data-sc-empty]');
    var checkoutBtn = $('[data-sc-checkout]');
    if (!itemsEl || !emptyEl) return;
    var data = state.data;
    if (!data || !data.items || data.items.length === 0) {
      itemsEl.innerHTML = '';
      emptyEl.removeAttribute('hidden');
      if (checkoutBtn) checkoutBtn.disabled = true;
      return;
    }
    emptyEl.setAttribute('hidden', '');
    if (checkoutBtn) checkoutBtn.disabled = false;
    var trashSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';
    var html = data.items.map(function (item) {
      var img = item.image || item.featured_image || '';
      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? esc(item.variant_title) : '';
      /* nome compacto: só a parte antes do 1º " - " (títulos longos quebravam em 5+ linhas no mobile) */
      var shortTitle = String(item.product_title || '').split(' - ')[0];
      /* 17/07: no cart mostra só "Kit Completão" (o produto C/ Protetor é temporário —
         será consolidado no kit-completao antes do go-live) */
      shortTitle = shortTitle.replace(/\s*C\/\s*Protetor\s*Solar.*$/i, '');
      return '<li class="pj-sc-item" data-key="' + esc(item.key) + '">' +
        (img ? '<img class="pj-sc-item-img" src="' + esc(img) + '" alt="">' : '<div class="pj-sc-item-img"></div>') +
        '<div class="pj-sc-item-info">' +
          '<strong class="pj-sc-item-title">' + esc(shortTitle) + '</strong>' +
          (variantTitle ? '<span class="pj-sc-item-variant">' + variantTitle + '</span>' : '') +
          (function () {
            /* assinatura (selling plan) — mostra SÓ a recorrência ("Entrega mensal");
               o app gera "Entrega mensal, Desconto de R$ X" e o sufixo sai da exibição */
            var spa = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
            if (!spa || !spa.name) return '';
            var label = String(spa.name).replace(/,?\s*desconto\b.*$/i, '').trim();
            return '<span class="pj-sc-item-plan">↻ ' + esc(label) + '</span>';
          })() +
          '<div class="pj-sc-item-qty">' +
            '<button type="button" data-sc-qty="dec" aria-label="Reduzir">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-sc-qty="inc" aria-label="Aumentar">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="pj-sc-item-side">' +
          '<button type="button" class="pj-sc-item-remove" data-sc-remove aria-label="Remover item">' + trashSvg + '</button>' +
          (function () {
            /* riscado = o MAIOR entre compare_at ("de") e o preço pré-desconto do carrinho */
            var paying = item.final_line_price;
            var struck = 0;
            var cmpUnit = cmpCache[item.variant_id] || 0;
            if (cmpUnit * item.quantity > paying) struck = cmpUnit * item.quantity;
            if (item.original_line_price > paying && item.original_line_price > struck) struck = item.original_line_price;
            return '<strong class="pj-sc-item-price">' +
              (struck > 0 ? '<s class="pj-sc-item-orig">R$ ' + fmt(struck) + '</s> ' : '') +
              'R$ ' + fmt(paying) + '</strong>';
          })() +
        '</div>' +
      '</li>';
    }).join('');
    /* 16/09: linhas de BRINDE só demonstrativas (a Yever adiciona o brinde no checkout; nada entra no /cart).
       data-sc-gift-line = o gate do Deep Blue pula estas linhas na contagem de barras */
    var totalNow = data.total_price || 0, giftsHtml = '';
    giftTiers().forEach(function (t) {
      if (totalNow < t.cents) return;
      giftsHtml += '<li class="pj-sc-item pj-sc-item--gift" data-sc-gift-line>' +
        (t.img ? '<img class="pj-sc-item-img" src="' + esc(t.img) + '" alt="">' : '<div class="pj-sc-item-img"></div>') +
        '<div class="pj-sc-item-info">' +
          '<strong class="pj-sc-item-title">' + esc(t.name || t.label) + '</strong>' +
          '<span class="pj-sc-item-variant"><em class="pj-sc-item-gifttag">Brinde</em><span>1 un</span></span>' +
          '<span class="pj-sc-item-giftfrom">Pedido acima de ' + reais(t.cents) + '</span>' +
        '</div>' +
        '<div class="pj-sc-item-side">' +
          '<strong class="pj-sc-item-price">' + (t.value > 0 ? '<s class="pj-sc-item-orig">R$ ' + fmt(t.value) + '</s> ' : '') + '<em class="pj-sc-item-free">R$ 0,00</em></strong>' +
        '</div>' +
      '</li>';
    });
    itemsEl.innerHTML = giftsHtml + html;
  }

  function renderSubtotal() {
    var el = $('[data-sc-subtotal]');
    var pixEl = $('[data-sc-pix-value]');
    var total = (state.data && state.data.total_price) || 0;
    /* Preço cheio (Σ compare_at riscado por item) + Desconto ÚNICO (promos de produto + progressivo somados) */
    var items = (state.data && state.data.items) || [];
    var fullTotal = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var cmpUnit = cmpCache[it.variant_id] || 0;
      fullTotal += Math.max(cmpUnit * it.quantity, it.original_line_price || 0);
    }
    /* brindes (demonstrativos) entram em "Você economiza" pelo valor cheio */
    giftTiers().forEach(function (t) { if (total >= t.cents && t.value > 0) fullTotal += t.value; });
    var discTotal = Math.max(0, fullTotal - total);
    var savBox = $('[data-sc-savings]');
    var fullVal = $('[data-sc-full-value]');
    var discVal = $('[data-sc-discount-value]');
    var pctEl = $('[data-sc-discount-pct]');
    var show = discTotal > 0;
    if (savBox) {
      savBox.hidden = !show;
      if (show) {
        if (fullVal) fullVal.textContent = 'R$ ' + fmt(fullTotal);
        if (discVal) discVal.textContent = '− R$ ' + fmt(discTotal);
        if (pctEl) pctEl.textContent = '-' + Math.round(discTotal / fullTotal * 100) + '%';
      }
    }

    /* Parcelas: tabela Price 2% a.m. (mesma conta que o checkout usava na era Yampi —
       validar contra o parcelamento configurado na Yever), escolhendo o nº de
       parcelas (2-12) cujo valor fica mais perto de R$ 30. 1x não mostra. */
    var parcelRow = $('[data-sc-parcel-row]');
    var parcelEl = $('[data-sc-parcel]');
    if (parcelRow && parcelEl) {
      var bestN = 1, bestDiff = Math.abs(total - 3000);
      for (var n = 2; n <= 12; n++) {
        var pmt = Math.round(total * 0.02 / (1 - Math.pow(1.02, -n)));
        var diff = Math.abs(pmt - 3000);
        if (diff < bestDiff) { bestDiff = diff; bestN = n; }
      }
      if (total > 0 && bestN >= 2) {
        var bestPmt = Math.round(total * 0.02 / (1 - Math.pow(1.02, -bestN)));
        parcelEl.innerHTML = 'ou <b>' + bestN + 'x de R$ ' + fmt(bestPmt) + '</b>';
        parcelRow.hidden = false;
      } else {
        parcelRow.hidden = true;
      }
    }
    if (el) el.textContent = 'R$ ' + fmt(total);
    // Preço no PIX: 2% off. Math.round trabalha em cents (total_price já é cents).
    if (pixEl) pixEl.textContent = 'R$ ' + fmt(Math.round(total * 0.98));
  }

  function renderFreight() {
    var freightEl = $('[data-sc-freight]');
    var textEl = $('[data-sc-freight-text]');
    var fillEl = $('[data-sc-freight-fill]');
    var truckEl = $('[data-sc-freight-truck]');
    var giftEls = [].slice.call(document.querySelectorAll('[data-sc-freight-gift]'));
    if (!textEl || !fillEl || !freightEl) return;
    var T = giftTiers();
    var total = (state.data && state.data.total_price) || 0;
    /* marcos igualmente espaçados na barra: frete grátis + os brindes */
    var marcos = [{ cents: FREE_SHIPPING_CENTS, frete: true }].concat(T);
    var passo = 100 / marcos.length;
    if (truckEl) truckEl.style.left = passo + '%';
    var nextSet = false;
    giftEls.forEach(function (g, i) {
      var t = T[i];
      if (!t) { g.hidden = true; return; }
      g.hidden = false;
      g.style.left = (passo * (i + 2)) + '%';
      var hit = total >= t.cents;
      g.classList.toggle('is-hit', hit);
      g.classList.toggle('is-next', !hit && !nextSet);
      if (!hit) nextSet = true;
    });
    /* fill: interpola dentro do segmento atual, pra barra andar sempre */
    var pct = 100, anterior = 0;
    for (var mi = 0; mi < marcos.length; mi++) {
      if (total >= marcos[mi].cents) { anterior = marcos[mi].cents; continue; }
      var faixa = marcos[mi].cents - anterior;
      pct = passo * mi + (faixa > 0 ? (total - anterior) / faixa * passo : 0);
      break;
    }
    fillEl.style.width = Math.max(0, Math.min(100, pct)) + '%';
    var freeOk = total >= FREE_SHIPPING_CENTS;
    freightEl.classList.toggle('is-free', freeOk);
    var CHECK = '<span class="pj-sc-freight-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>';
    var prox = null;
    for (var pi = 0; pi < marcos.length; pi++) { if (total < marcos[pi].cents) { prox = marcos[pi]; break; } }
    var ganhos = 0;
    T.forEach(function (t) { if (total >= t.cents) ganhos++; });
    if (!prox) {
      textEl.innerHTML = CHECK + '<span>Boa! <strong>Frete grátis + ' + T.length + ' brindes</strong> garantidos.</span>';
    } else if (!freeOk) {
      textEl.innerHTML = 'Faltam <strong>R$ ' + fmt(prox.cents - total) + '</strong> pro frete grátis';
    } else {
      var pre = ganhos === 0 ? 'Frete grátis garantido!' : (ganhos === 1 ? '1 brinde garantido!' : ganhos + ' brindes garantidos!');
      textEl.innerHTML = CHECK + '<span>' + pre + ' Faltam <strong>R$ ' + fmt(prox.cents - total) + '</strong> pro <strong>' + esc(prox.name ? prox.name + ' grátis' : prox.label) + '</strong></span>';
    }
    /* "calcular frete" recolhido muda de rótulo quando o frete já é grátis */
    var cepTxt = $('[data-sc-cep-toggle-txt]');
    if (cepTxt) { var ct = freeOk ? 'Frete grátis · ver prazo de entrega' : 'Calcular frete e prazo'; if (cepTxt.textContent !== ct) cepTxt.textContent = ct; }
  }

  function changeQty(itemKey, qty) {
    return trackMutation(fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: itemKey, quantity: qty }),
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      state.data = data;
      state.fetchedAt = Date.now();
      render();
      warmCheckout(); // cart mudou → re-aquece URL pro novo estado
    })
    .catch(function (err) { console.error('[pj-sc] change:', err); }));
  }

  function addItem(variantId, quantity, opts) {
    /* opts.sellingPlan (15/07, Yever/V15): id de selling plan (Shopify Subscriptions) — item vira assinatura */
    var line = { id: parseInt(variantId, 10), quantity: quantity || 1 };
    if (opts && opts.sellingPlan) line.selling_plan = parseInt(opts.sellingPlan, 10);
    if (opts && opts.properties) line.properties = opts.properties;
    var payload = { items: [line] };
    console.log('[pj-sc] /cart/add.js payload:', payload);
    return trackMutation(fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
    .then(function (r) {
      console.log('[pj-sc] /cart/add.js status:', r.status);
      return r.text().then(function (txt) {
        if (!r.ok) {
          console.error('[pj-sc] /cart/add.js error body:', txt);
          var msg;
          try { var j = JSON.parse(txt); msg = j.description || j.message || ('add_failed_' + r.status); }
          catch (_) { msg = 'add_failed_' + r.status; }
          throw new Error(msg);
        }
        return JSON.parse(txt);
      });
    })
    .then(function () {
      state.fetchedAt = 0; // força refetch após add
      return load(true);
    }));
  }

  /* CEP calculator. Busca UF via ViaCEP (necessário pra Shopify processar BR),
     manda pro /cart/prepare_shipping_rates, polling em /cart/async_shipping_rates.
     Se 422 persistir, fallback pro endpoint síncrono /cart/shipping_rates.json. */
  function loadShippingRates(zip) {
    var ratesEl = $('[data-sc-rates]');
    if (!ratesEl) return Promise.resolve();
    ratesEl.removeAttribute('hidden');
    ratesEl.innerHTML = '<span class="pj-sc-rates-loading">Calculando frete...</span>';

    return fetch('https://viacep.com.br/ws/' + zip + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (cepData) {
        console.log('[pj-sc] ViaCEP resp:', cepData);
        if (cepData.erro) throw new Error('CEP não encontrado');
        var province = cepData.uf || '';
        var city = cepData.localidade || '';
        var body = 'shipping_address[zip]=' + encodeURIComponent(zip) +
                   '&shipping_address[country]=BR' +
                   '&shipping_address[province]=' + encodeURIComponent(province) +
                   '&shipping_address[city]=' + encodeURIComponent(city);
        return fetch('/cart/prepare_shipping_rates', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
          credentials: 'same-origin'
        })
        .then(function (r) {
          console.log('[pj-sc] prepare status:', r.status);
          return r.text();
        })
        .then(function (txt) {
          console.log('[pj-sc] prepare body returned:', txt || '(empty)');
          if (txt) {
            try {
              var parsed = JSON.parse(txt);
              if (parsed && parsed.zip) throw new Error(parsed.zip[0] || 'CEP inválido');
              if (parsed && parsed.province) throw new Error('Estado inválido pro CEP');
              if (parsed && parsed.error) throw new Error(parsed.error);
            } catch (e) {
              if (!(e instanceof SyntaxError)) throw e;
            }
          }
          var attempts = 0;
          function tryFetch() {
            attempts++;
            return fetch('/cart/async_shipping_rates', {
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              credentials: 'same-origin'
            })
            .then(function (rr) {
              console.log('[pj-sc] async status (attempt ' + attempts + '):', rr.status);
              if (rr.status === 422) {
                return rr.text().then(function (t) {
                  console.error('[pj-sc] async 422 body:', t);
                  throw new Error('async_422');
                });
              }
              return rr.json();
            })
            .then(function (resp) {
              console.log('[pj-sc] async resp (attempt ' + attempts + '):', resp);
              if (!resp || resp.shipping_rates == null) {
                /* apps de cotação (Olist/FM) podem levar 6-15s numa cotação fria —
                   8x700ms (~5,6s) estourava e mostrava erro de "zonas" à toa (20/07) */
                if (attempts < 20) {
                  return new Promise(function (res) { setTimeout(res, 800); }).then(tryFetch);
                }
                return { shipping_rates: [], _gaveUp: true };
              }
              return resp;
            });
          }
          return tryFetch().catch(function (err) {
            if (err.message === 'async_422') {
              console.log('[pj-sc] fallback /cart/shipping_rates.json');
              var qs = '?shipping_address[zip]=' + encodeURIComponent(zip) +
                       '&shipping_address[country]=BR' +
                       '&shipping_address[province]=' + encodeURIComponent(province);
              return fetch('/cart/shipping_rates.json' + qs, {
                headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin'
              })
              .then(function (rrr) {
                console.log('[pj-sc] shipping_rates.json status:', rrr.status);
                return rrr.json();
              })
              .then(function (jj) {
                console.log('[pj-sc] shipping_rates.json resp:', jj);
                return { shipping_rates: jj.shipping_rates || [] };
              });
            }
            throw err;
          });
        });
      })
      .then(function (resp) {
        var rates = (resp && resp.shipping_rates) || [];
        if (!rates.length) {
          var hint = resp && resp._gaveUp
            ? 'A cotação demorou mais que o normal. Clique em OK pra tentar de novo.'
            : 'Não entregamos nesse CEP. Confere se digitou certo?';
          ratesEl.innerHTML = '<span class="pj-sc-rates-error">' + hint + '</span>';
          return;
        }
        function toCents(price) {
          if (typeof price === 'number') return price > 100 ? price : Math.round(price * 100);
          if (typeof price === 'string') {
            var clean = price.replace(/[^\d.,]/g, '').replace(',', '.');
            var n = parseFloat(clean);
            return isNaN(n) ? 0 : Math.round(n * 100);
          }
          return 0;
        }
        /* 21/07: item de ASSINATURA no carrinho faz o app Subscriptions publicar
           uma "Entrega Padrão" R$0 na cotação nativa do cart — que o checkout
           Yever NÃO aplica (cota direto na transportadora). Abaixo da regra real
           de frete grátis da loja (R$250), taxa zero é descartada da lista pra
           cotação não prometer o que o checkout vai negar. */
        var cartTotalCents = (state.data && state.data.total_price) || 0;
        if (cartTotalCents < FREE_SHIPPING_CENTS) {
          var paidRates = rates.filter(function (r) { return toCents(r.price) > 0; });
          if (paidRates.length) rates = paidRates;
        }
        // Extrai o prazo de entrega: tenta delivery_days[0] (pode ser 0 = mesmo dia/amanhã),
        // depois delivery_range, ISO dates, e por último número no nome. Retorna null se nada.
        function getDeliveryDays(rate) {
          if (rate.delivery_days && rate.delivery_days.length) {
            var d = rate.delivery_days[0];
            if (typeof d === 'number') return d;
            var n = parseInt(d, 10);
            if (!isNaN(n)) return n;
          }
          if (rate.delivery_range && rate.delivery_range.length) {
            var last = rate.delivery_range[rate.delivery_range.length - 1];
            var nn = parseInt(last, 10);
            if (!isNaN(nn)) return nn;
          }
          var iso = rate.max_delivery_date || rate.min_delivery_date;
          if (iso) {
            try {
              var end = new Date(iso);
              var now = new Date();
              var diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
              if (diff >= 0 && diff < 90) return diff;
            } catch (_) {}
          }
          var m = (rate.name || '').match(/(\d+)\s*(dia|day)/i);
          if (m) return parseInt(m[1], 10);
          return null;
        }
        function formatDeliveryDays(days) {
          if (days === null) return '';
          if (days === 0) return 'Amanhã';
          if (days === 1) return '1 dia útil';
          return days + ' dias úteis';
        }
        var html = '<ul>' + rates.map(function (rate) {
          console.log('[pj-sc] rate detail:', rate);
          var cents = toCents(rate.price);
          var priceStr = cents === 0
            ? '<span class="pj-sc-rate-free">Grátis</span>'
            : '<span class="pj-sc-rate-price">R$ ' + fmt(cents) + '</span>';
          var daysText = formatDeliveryDays(getDeliveryDays(rate));
          return '<li>' +
            '<div><div class="pj-sc-rate-name">' + esc(rate.name || rate.presentment_name || '') + '</div>' +
            (daysText ? '<div class="pj-sc-rate-meta">' + daysText + '</div>' : '') +
            '</div>' + priceStr + '</li>';
        }).join('') + '</ul>';
        ratesEl.innerHTML = html;
      })
      .catch(function (err) {
        console.error('[pj-sc] shipping rates error:', err);
        ratesEl.innerHTML = '<span class="pj-sc-rates-error">' + (err.message || 'Erro ao calcular o frete.') + '</span>';
      });
  }

  /* ===== Checkout YEVER (16/07 — substitui o fluxo Yampi) =====
     A Yever processa COMPRA ÚNICA e ASSINATURA no mesmo checkout — sem split:
     todo carrinho vai pro POST em YEVER_CART_ENDPOINT e redireciona pra URL
     retornada ({ url, active, skip_cart }).
     FAST PATH (cache hit): URL pré-aquecida via warmCheckout() ao abrir o
       drawer / mudar cart. Redirect imediato (~50ms).
     SLOW PATH (cache miss): POST inline; usa state.data se fresco.
     FALHA (active === false, sem URL, timeout ou erro de rede): NÃO redireciona
       pra lugar nenhum — decisão 17/07: checkout é SÓ Yever, sem fallback pro
       /checkout nativo. O botão volta ao normal com mensagem de "tente de novo"
       e o próximo clique refaz o POST.
     vs Yampi: o carrinho NÃO é limpo (a Yever usa o cart/token da Shopify) e a
     URL é decorada NO CLIQUE com UTMs + cookies de tracking + token + cupom —
     via getUrlWithUtmsYever() do snippet yever-checkout.liquid quando presente,
     senão pelo fallback local abaixo (mesmo cookie yeverUtmsTrack, mesma lista
     de cookies). O cookie yeverCartProperties também é gravado antes do
     redirect (mesmo formato base64 do snippet). */
  function cartHasSellingPlan(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) { if (items[i].selling_plan_allocation) return true; }
    return false;
  }

  /* helpers locais — espelham EXATAMENTE os formatos do yever-checkout.liquid */
  function yeverSetCookie(name, value) {
    var date = new Date();
    date.setTime(date.getTime() + 2592000000); /* 30 dias, igual ao snippet */
    var domain = window.location.host.replace('www.', '');
    document.cookie = name + '=' + (value || '') + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax;domain=' + domain + ';';
  }
  function yeverGetCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return m ? m[1] : null;
  }
  function yeverCartPropsB64(cart) {
    var json = JSON.stringify({
      token: cart.token,
      note: cart.note,
      attributes: cart.attributes,
      items: (cart.items || []).map(function (it) {
        return { id: it.id, properties: it.properties, variant_id: it.variant_id, key: it.key, sku: it.sku, product_id: it.product_id };
      })
    });
    return btoa(encodeURIComponent(json).replace(/%([0-9A-F]{2})/g, function (_, p1) { return String.fromCharCode('0x' + p1); }));
  }
  function yeverCupom(cart) {
    try {
      var d = cart && cart.discount_codes && cart.discount_codes.find(function (x) { return x.applicable; });
      return d ? d.code : null;
    } catch (_) { return null; }
  }
  function yeverDecorateUrl(url, cart) {
    var cupom = yeverCupom(cart);
    var token = cart && cart.token;
    /* preferir a função do snippet (fonte da verdade da Yever) */
    if (typeof window.getUrlWithUtmsYever === 'function') {
      try { return window.getUrlWithUtmsYever(url, cupom, token); } catch (_) {}
    }
    /* fallback local idêntico — cookie histórico + params da URL ATUAL (o
       snippet captura a URL pro cookie em todo pageload; sem ele, garantimos
       ao menos os parâmetros da sessão corrente) */
    try {
      var u = new URL(url);
      var utms = yeverGetCookie('yeverUtmsTrack');
      if (utms) {
        new URLSearchParams(utms).forEach(function (v, k) { u.searchParams.set(k, v); });
      }
      var ADS_KEYS = ['gclid', 'gbraid', 'wbraid', 'srsltid', 'dclid', 'gclsrc', '_gl', 'fbclid', 'ttclid', 'ttp', 'epik', 'pin_unauth', 'tblci', 'kwaicid', 'cupom'];
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        if (!v) return;
        if (k.indexOf('utm_') === 0 || k.indexOf('gad_') === 0 || ADS_KEYS.indexOf(k) !== -1) {
          u.searchParams.set(k, v);
        }
      });
      if (token) u.searchParams.set('token', token);
      if (cupom) u.searchParams.set('cupom', cupom);
      ['_ga', '_gcl_aw', '_gcl_dc', '_fbp', '_fbc', '_ttp', '_epik', '_pin_unauth'].forEach(function (c) {
        var v = yeverGetCookie(c);
        if (v) u.searchParams.set(c, v);
      });
      return u.href;
    } catch (_) { return url; }
  }

  // PostHog: pj_quiz_begin_checkout — só dispara se o user veio do quiz
  // (state.completedAt != null no localStorage). PostHog SDK usa fetch
  // keepalive automaticamente, então o evento sobrevive ao navigate.
  // 27/07: + 'begin_checkout' CANÔNICO (sem prefixo), SEMPRE — camada site-wide
  // pro funil pageview > add_to_cart > begin_checkout (o do quiz segue existindo).
  function trackBeginCheckout(destination, cart) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture('begin_checkout', {
          currency: 'BRL',
          value: ((cart && cart.total_price) || 0) / 100,
          destination: destination,
          mode: cartHasSellingPlan(cart) ? 'assinatura' : 'unica'
        });
      }
    } catch (_) {}
    try {
      var raw = localStorage.getItem('proper_diagnostic_state');
      if (raw && window.posthog && typeof window.posthog.capture === 'function') {
        var st = JSON.parse(raw);
        if (st && st.completedAt) {
          window.posthog.capture('pj_quiz_begin_checkout', {
            currency: 'BRL',
            destination: destination,
            mode: cartHasSellingPlan(cart) ? 'assinatura' : 'unica',
            dor_principal: (st.answers && st.answers.principalDor) || ''
          });
        }
      }
    } catch (_) {}
  }

  function checkoutYever() {
    var btn = $('[data-sc-checkout]');
    if (btn) {
      if (btn.disabled) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    function doRedirect(url, cart) {
      try { var e0 = document.querySelector('.pj-sc-checkout-err'); if (e0) e0.hidden = true; } catch (_) {}
      /* cookie de propriedades do carrinho — a Yever lê no checkout */
      try { yeverSetCookie('yeverCartProperties', yeverCartPropsB64(cart)); } catch (_) {}
      trackBeginCheckout('yever', cart);
      /* Meta InitiateCheckout (20/07): no tema novo o hook da Yampi (ymp_getUrlWithUtms,
         monkey-patchado pelo snippet Solomon) nunca dispara — sem isto a Meta ficaria
         cega no meio do funil. eventID no padrão do Solomon p/ dedup com CAPI. */
      try {
        if (typeof window.fbq === 'function' && cart) {
          var icEid = 'InitiateCheckout_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
          var icIds = (cart.items || []).map(function (i) { return String(i.product_id); });
          var icValue = (cart.total_price || 0) / 100;
          window.fbq('track', 'InitiateCheckout', {
            currency: 'BRL',
            value: icValue,
            num_items: cart.item_count || 0,
            content_ids: icIds,
            content_type: 'product_group'
          }, { eventID: icEid });
          /* espelho server-side (worker pj-capi) com o MESMO event_id — dedup no Meta */
          if (window.__pjCapiRelay) window.__pjCapiRelay('InitiateCheckout', { content_ids: icIds, value: icValue }, icEid);
        }
      } catch (_) {}
      /* invalida a URL usada: se o user voltar (bfcache) e clicar de novo,
         geramos URL nova — igual ao fluxo nativo, que POSTa a cada clique */
      checkoutCache.url = null;
      checkoutCache.cartKey = null;
      window.location.href = yeverDecorateUrl(url, cart);
    }
    function checkoutFail(motivo) {
      /* SEM fallback pro checkout nativo (decisão 17/07: só Yever). Reabilita
         o botão e mostra aviso — o próximo clique tenta de novo. */
      console.error('[pj-sc] Yever indisponível:', motivo);
      if (btn) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
      try {
        var err = document.querySelector('.pj-sc-checkout-err');
        if (!err && btn) {
          err = document.createElement('div');
          err.className = 'pj-sc-checkout-err';
          err.style.cssText = 'margin:0 0 8px;font-size:12px;line-height:1.4;color:#b3261e;text-align:center;';
          btn.parentNode.insertBefore(err, btn);
        }
        if (err) {
          err.textContent = 'Não conseguimos abrir o pagamento agora. Tente novamente em instantes.';
          err.hidden = false;
        }
      } catch (_) {}
    }

    /* ESPERA mutação em voo (tap no +/− imediatamente antes do clique) e
       garante carrinho FRESCO (<5s): payload/cupom/cookie sempre condizem com
       o cart real — mesma garantia do endShopping nativo, que refetcha no clique */
    var wait = pendingMutation ? pendingMutation.catch(function () {}) : Promise.resolve();
    return wait
      .then(function () {
        var fresh = state.data && (Date.now() - state.fetchedAt) < CART_CACHE_MS;
        if (fresh) return state.data;
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (d) { state.data = d; state.fetchedAt = Date.now(); return d; });
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) {
          /* carrinho esvaziou (outra aba?) — nada a finalizar */
          if (btn) { btn.classList.remove('is-loading'); }
          render();
          return;
        }
        // FAST PATH — URL pré-aquecida pro cart FRESCO (URL é estável por carrinho)
        var key = cartKey(cart);
        if (checkoutCache.url && checkoutCache.cartKey === key) {
          doRedirect(checkoutCache.url, cart);
          return;
        }
        // SLOW PATH — POST inline, com timeout (Yever pendurada → fallback)
        var opts = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            payload: cart,
            shopifyDomain: (window.Shopify && window.Shopify.shop) || 'properjack.myshopify.com'
          })
        };
        var ctl = null, tId = null;
        if ('AbortController' in window) {
          ctl = new AbortController();
          opts.signal = ctl.signal;
          tId = setTimeout(function () { try { ctl.abort(); } catch (_) {} }, 6000);
        }
        return fetch(YEVER_CART_ENDPOINT, opts)
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            if (tId) clearTimeout(tId);
            if (resp && resp.active === false) { checkoutFail('active_false'); return; }
            if (!resp || !resp.url) throw new Error('no_checkout_url');
            doRedirect(resp.url, cart);
          })
          .catch(function (err) {
            if (tId) clearTimeout(tId);
            checkoutFail(err);
          });
      })
      .catch(function (err) {
        checkoutFail(err);
      });
  }

  /* 17/07: modal de detalhes do order bump — preenchido com os data-up-* do item */
  function openUpsellDetail(li) {
    var m = $('[data-sc-dmodal]');
    if (!m) return;
    var img = $('[data-sc-dmodal-img]');
    var name = $('[data-sc-dmodal-name]');
    var desc = $('[data-sc-dmodal-desc]');
    var chips = $('[data-sc-dmodal-chips]');
    var price = $('[data-sc-dmodal-price]');
    /* galeria completa do produto (data-up-imgs = URLs separadas por |) */
    var imgList = (li.getAttribute('data-up-imgs') || '').split('|').filter(Boolean);
    if (!imgList.length && li.getAttribute('data-up-img')) imgList = [li.getAttribute('data-up-img')];
    if (img) img.src = imgList[0] || '';
    var twrap = $('[data-sc-dmodal-thumbs]');
    if (twrap) {
      twrap.innerHTML = '';
      if (imgList.length > 1) {
        imgList.forEach(function (u, i) {
          var b = document.createElement('button');
          b.type = 'button';
          if (i === 0) b.className = 'is-on';
          b.setAttribute('data-dmodal-thumb', u);
          b.setAttribute('aria-label', 'Foto ' + (i + 1));
          var im = document.createElement('img');
          im.src = u;
          im.alt = '';
          im.loading = 'lazy';
          b.appendChild(im);
          twrap.appendChild(b);
        });
      }
    }
    if (name) name.textContent = li.getAttribute('data-up-title') || '';
    if (desc) desc.textContent = li.getAttribute('data-up-desc') || '';
    if (price) price.textContent = 'R$ ' + (li.getAttribute('data-up-price') || '');
    if (chips) {
      chips.innerHTML = '';
      (li.getAttribute('data-up-chips') || '').split('|').forEach(function (c) {
        c = c.trim();
        if (!c) return;
        var s = document.createElement('span');
        s.textContent = c;
        chips.appendChild(s);
      });
    }
    var add = m.querySelector('[data-sc-upsell-add]');
    if (add) {
      add.setAttribute('data-sc-upsell-add', li.getAttribute('data-variant-id') || '');
      add.disabled = false;
    }
    m.hidden = false;
  }
  function closeUpsellDetail() {
    var m = $('[data-sc-dmodal]');
    if (m) m.hidden = true;
  }

  var wired = false;
  function wire() {
    if (wired) return;
    var root = getRoot();
    if (!root) return;
    wired = true;

    // Close via backdrop/X/[data-sc-close]
    root.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== root) {
        if (t.hasAttribute && t.hasAttribute('data-sc-close')) { e.preventDefault(); close(); return; }
        t = t.parentElement;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      /* Esc fecha o modal de detalhes primeiro; segundo Esc fecha o drawer */
      var dm = $('[data-sc-dmodal]');
      if (dm && !dm.hidden) { closeUpsellDetail(); return; }
      if (root.classList.contains('is-open')) close();
    });

    // Delegated: qty +/-, remove, upsell
    root.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest && e.target.closest('[data-sc-qty]');
      if (qtyBtn) {
        e.preventDefault(); e.stopPropagation();
        var item = qtyBtn.closest('.pj-sc-item');
        if (!item) return;
        var key = item.dataset.key;
        var current = parseInt(item.querySelector('.pj-sc-item-qty span').textContent, 10) || 1;
        var newQty = qtyBtn.dataset.scQty === 'inc' ? current + 1 : Math.max(0, current - 1);
        changeQty(key, newQty);
        return;
      }
      var removeBtn = e.target.closest && e.target.closest('[data-sc-remove]');
      if (removeBtn) {
        e.preventDefault(); e.stopPropagation();
        var item2 = removeBtn.closest('.pj-sc-item');
        if (!item2) return;
        changeQty(item2.dataset.key, 0);
        return;
      }
      var upsellBtn = e.target.closest && e.target.closest('[data-sc-upsell-add]');
      if (upsellBtn) {
        e.preventDefault(); e.stopPropagation();
        var vid = upsellBtn.getAttribute('data-sc-upsell-add');
        if (!vid) return;
        upsellBtn.disabled = true;
        addItem(vid, 1)
          .then(function () {
            upsellBtn.disabled = false;
            /* add veio de dentro do modal de detalhes → fecha o modal */
            if (upsellBtn.closest('[data-sc-dmodal]')) closeUpsellDetail();
          })
          .catch(function (err) {
            console.error('[pj-sc] upsell add failed:', err);
            upsellBtn.disabled = false;
          });
        return;
      }
      /* 17/07: fechar modal de detalhes (backdrop / X) */
      var dmCloseBtn = e.target.closest && e.target.closest('[data-sc-dmodal-close]');
      if (dmCloseBtn) { e.preventDefault(); e.stopPropagation(); closeUpsellDetail(); return; }
      /* thumbs da galeria do modal — troca a foto principal */
      var dmThumb = e.target.closest && e.target.closest('[data-dmodal-thumb]');
      if (dmThumb) {
        e.preventDefault(); e.stopPropagation();
        var mi = $('[data-sc-dmodal-img]');
        if (mi) mi.src = dmThumb.getAttribute('data-dmodal-thumb');
        $$('[data-dmodal-thumb]').forEach(function (t) { t.classList.remove('is-on'); });
        dmThumb.classList.add('is-on');
        return;
      }
      /* 17/07: clique no item do order bump (fora do +) abre o modal de detalhes
         — padrão do "Monte seu Kit" */
      var detailLi = e.target.closest && e.target.closest('[data-sc-detail]');
      if (detailLi) {
        e.preventDefault(); e.stopPropagation();
        openUpsellDetail(detailLi);
        return;
      }
      /* Checkout — DELEGADO de propósito: o yeverEvent() do snippet clona
         botões que batem nos seletores dele (perderia listener direto);
         delegação no root sobrevive a qualquer cloneNode. */
      var ckBtn = e.target.closest && e.target.closest('[data-sc-checkout]');
      if (ckBtn) {
        e.preventDefault(); e.stopPropagation();
        checkoutYever();
        return;
      }
    });

    // 16/09: "calcular frete" recolhido (abre ao toque)
    var cepToggle = $('[data-sc-cep-toggle]'), cepBox = $('[data-sc-cep-box]');
    if (cepToggle && cepBox) {
      cepToggle.addEventListener('click', function () {
        var abre = cepBox.hidden;
        cepBox.hidden = !abre;
        cepToggle.classList.toggle('is-open', abre);
        cepToggle.setAttribute('aria-expanded', abre ? 'true' : 'false');
        if (abre) { var zi = $('#pj-sc-zip'); if (zi) { try { zi.focus({ preventScroll: true }); } catch (e) {} } }
      });
    }
    // 16/09: toque no marco do brinde mostra o que é / a partir de quanto
    var tipTimer = null;
    root.addEventListener('click', function (e) {
      var tip = $('[data-sc-gift-tip]');
      if (!tip) return;
      var g = e.target.closest && e.target.closest('[data-sc-freight-gift]');
      if (!g) { if (!tip.hidden) tip.hidden = true; return; }
      e.preventDefault(); e.stopPropagation();
      var i = parseInt(g.getAttribute('data-sc-freight-gift'), 10) || 0, t = giftTiers()[i];
      if (!t) return;
      var nome = t.name || t.label;
      tip.textContent = g.classList.contains('is-hit') ? nome + ' grátis: já está no seu pedido' : nome + ' grátis a partir de ' + reais(t.cents);
      tip.hidden = false;
      var wrap = tip.offsetParent || g.parentNode.parentNode;
      var gr = g.getBoundingClientRect(), wr = wrap.getBoundingClientRect();
      var alvo = gr.left + gr.width / 2 - wr.left, half = tip.offsetWidth / 2;
      var cx = Math.max(half + 8, Math.min(wr.width - half - 8, alvo));
      tip.style.left = cx + 'px';
      tip.style.setProperty('--arrow', (alvo - (cx - half)) + 'px');
      clearTimeout(tipTimer); tipTimer = setTimeout(function () { tip.hidden = true; }, 3000);
    });

    // CEP
    var zipInput = $('#pj-sc-zip');
    if (zipInput) {
      zipInput.addEventListener('input', function () {
        var v = zipInput.value.replace(/\D/g, '').slice(0, 8);
        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
        zipInput.value = v;
      });
      zipInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var btn = $('[data-sc-cep-go]');
          if (btn) btn.click();
        }
      });
    }
    var cepBtn = $('[data-sc-cep-go]');
    if (cepBtn) {
      cepBtn.addEventListener('click', function () {
        var zip = (zipInput && zipInput.value || '').replace(/\D/g, '');
        if (zip.length !== 8) {
          var rates = $('[data-sc-rates]');
          if (rates) { rates.removeAttribute('hidden'); rates.innerHTML = '<span class="pj-sc-rates-error">CEP inválido.</span>'; }
          return;
        }
        cepBtn.disabled = true;
        var p = loadShippingRates(zip);
        if (p && p.finally) p.finally(function () { cepBtn.disabled = false; });
        else if (p && p.then) p.then(function () { cepBtn.disabled = false; }, function () { cepBtn.disabled = false; });
      });
    }

    // Checkout: tratado no handler delegado acima (junto com qty/remove/upsell).
  }

  /* Intercepta cliques no ícone de cart do header pra abrir o NOSSO drawer.
     Capture phase no document pra rodar antes do cart-ajax.js (que usa jQuery
     delegado no body em bubble phase). Cobre múltiplos seletores pra resiliência
     em diferentes headers/breakpoints. Também esconde o drawer antigo se ele abrir. */
  var CART_SELECTORS = [
    '.cart-icon',
    '.openCartDrawer',
    '[data-cart-toggle]',
    '[data-cart-drawer-toggle]',
    '.cart-link',
    '.cart-btn',
    '.header-cart',
    '.wrapper-top-cart a',
    'a[href="#cart"]',
    '[aria-label="' + 'Carrinho' + '"]',
    '[aria-label="' + 'Cart' + '"]'
  ];
  function interceptCartIcons() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var icon = null;
      for (var i = 0; i < CART_SELECTORS.length; i++) {
        icon = e.target.closest(CART_SELECTORS[i]);
        if (icon) break;
      }
      if (!icon) return;
      var href = icon.getAttribute && icon.getAttribute('href');
      // Se for link explícito pra /cart sem hash, deixa navegar (página completa)
      if (href && href !== '#' && href.indexOf('/cart') === 0 && href.indexOf('#') === -1) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }, true);

    // Defesa em profundidade: se o cart antigo abrir mesmo assim, escondemos via JS.
    // Observa mudanças no body class (cart-ajax.js adiciona 'side_Drawer_open' ao abrir)
    if ('MutationObserver' in window) {
      var bodyObserver = new MutationObserver(function () {
        if (document.body.classList.contains('side_Drawer_open')) {
          var oldDrawer = document.querySelector('#mini__cart, [data-side-drawer].mini_cart');
          if (oldDrawer) {
            oldDrawer.style.display = 'none';
            document.body.classList.remove('side_Drawer_open');
            // Se já temos cart aberto, ignora. Senão, abre o nosso.
            var root = getRoot();
            if (root && !root.classList.contains('is-open')) open();
          }
        }
      });
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    // interceptCartIcons() é crítico — precisa estar pronto antes do user clicar no header.
    // wire() pode esperar (só executa quando o drawer é aberto pela 1ª vez).
    interceptCartIcons();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(wire, { timeout: 2000 });
    } else {
      setTimeout(wire, 0);
    }

    // 29/07: /cart era beco sem saída — o template legado esconde o submit
    // nativo (checkout só Yever) e o único FINALIZAR fica dentro do drawer
    // fechado. Quem cai em /cart (deep-link, bloqueio do checkout nativo,
    // histórico) agora recebe o drawer aberto por cima, com o botão Yever.
    // Idem pra quem VOLTA do checkout nativo (barrado pela validation do
    // BoomGate — ex.: botão de cupom do Meta): referrer /checkouts/ =
    // recuperação; abre o drawer pra levar direto pro FINALIZAR (Yever),
    // com o cupom já preso no carrinho.
    var voltouDoCheckout = /\/checkouts?\//.test(document.referrer || '');
    if (document.body.classList.contains('template_cart') || voltouDoCheckout) {
      setTimeout(open, 150);
    }

    // 16/07 (Yever): o pre-warm EAGER por pageview foi REMOVIDO de propósito.
    // Na era Yampi, todo page load com item no carrinho disparava um POST de
    // criação de checkout; com a Yever isso geraria sessões de checkout em
    // massa sem intenção de compra (métricas de abandono infladas, automações
    // disparadas à toa, risco de rate limit). O warm agora só roda com SINAL
    // DE INTENÇÃO: abrir o drawer / mudar o carrinho (open → load → warmCheckout).
    // Se a Yever confirmar que o volume é ok, é só restaurar o bloco do git/backup.

    // Voltou do checkout pelo botão "voltar" (bfcache): a página é restaurada
    // com o closure intacto — botão preso em is-loading, cache com URL já
    // usada e state possivelmente defasado. Reseta tudo e re-renderiza.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      checkoutCache.url = null;
      checkoutCache.cartKey = null;
      state.fetchedAt = 0;
      var btn = $('[data-sc-checkout]');
      if (btn) btn.classList.remove('is-loading');
      var root = getRoot();
      if (root && root.classList.contains('is-open')) load(true); /* re-render + re-habilita o botão */
    });
  }

  // Expor API global pra outros scripts (diagnostic.js usa pjSideCart.addItem + open)
  window.pjSideCart = {
    open: open,
    close: close,
    addItem: addItem,
    load: load
  };

  // init() roda direto no DOMContentLoaded — interceptCartIcons é crítico,
  // wire() é deferido internamente via requestIdleCallback.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();